const CLOSE_MS = 300;

const close = (details, answer) => {
  clearTimeout(details.faqCloseTimer);
  answer.style.maxHeight = '0px';
  answer.setAttribute('aria-hidden', 'true');

  details.faqCloseTimer = setTimeout(() => {
    details.open = false;
  }, CLOSE_MS);
};

const open = (details, answer) => {
  clearTimeout(details.faqCloseTimer);
  details.open = true;
  answer.setAttribute('aria-hidden', 'false');
  answer.style.maxHeight = `${answer.scrollHeight}px`;
};

export default (function () {
  return {
    init() {
      document.querySelectorAll('[data-component="cotopaxi-faq"]').forEach((root) => {
        root.addEventListener('click', (event) => {
          const summary = event.target.closest('.cotopaxi-faq__summary');

          if (!summary) {
            return;
          }

          const details = summary.closest('.cotopaxi-faq__item');

          if (!details) {
            return;
          }

          const answer = details.querySelector('.cotopaxi-faq__answer');

          if (!answer) {
            return;
          }
          event.preventDefault();

          const isOpen = answer.getAttribute('aria-hidden') === 'false';

          root.querySelectorAll('.cotopaxi-faq__answer[aria-hidden="false"]').forEach((openAnswer) => {
            const openDetails = openAnswer.closest('.cotopaxi-faq__item');

            if (openDetails && openDetails !== details) {
              close(openDetails, openAnswer);
            }
          });

          if (isOpen) {
            close(details, answer);
          } else {
            open(details, answer);
          }
        });
      });
    },
  };
})();
